<script setup lang="ts">
import type { Review } from '@shared/types/models'
import RateStars from '@/components/Product/ProductTabs/RateStars.vue'
import moment from 'moment'

type Props = {
    review: Review
}

const { review } = defineProps<Props>()
</script>

<template>
    <div class="bg-page px-2 py-3 border-b last:border-none space-y-2">
        <div class="flex justify-between item">
            <p class="flex items-center text-xl">
                <i class="lni lni-user font-bold mr-2.5"></i>

                <span class="font-bold mr-1">{{ review.name }}</span>

                <small class="text-main-hover">
                    ({{ $trans.get('reviews.rate') }} {{ review.rate }} {{ $trans.get('reviews.out_of') }} 5)
                </small>
            </p>

            <div class="text-sm text-right">
                <p>{{ $trans.get('reviews.published') }}</p>
                <p class="-mt-0.5">
                    <i class="lni lni-calendar mr-1"></i>
                    {{ moment(review.created_at).format('D.MM.YYYY') }}
                </p>
            </div>
        </div>

        <rate-stars :rate="review.rate" />

        <p v-if="review.comment">{{ review.comment }}</p>

        <div v-if="review.reply" class="ml-8 py-2">
            <div>
                <h2 class="font-bold text-">
                    <i class="lni lni-user font-bold mr-2.5"></i>
                    {{ review.reply.user!.name }}
                </h2>

                <p class="pl-5 ml-2 mt-2 border-l border-gray-300">
                    {{ review.reply.comment }}
                </p>
            </div>
        </div>
    </div>
</template>